<template>
  <div>
    <v-select
      @change="handleSelect"
      :label="$t('question.create.typeSelect')"
      :items="questionTypes"
      :value="value"
      item-value="value"
      item-text="name"
      outlined
    />
    <ModalConfirmTypeChange ref="modalConfirmTypeChange" @cancel="cancelTypeChange" />
  </div>
</template>
<script>
import ModalConfirmTypeChange from '@/components/questionnaire/ModalConfirmTypeChange'
export default {
  name: 'QuestionTypeSelect',
  props: {
    label: {
      required: false,
    },
    value: {
      required: true
    },
    answers: {
      type: Array,
      required: false
    },
  },
  components: {
    ModalConfirmTypeChange
  },
  data() {
    return {
      showSelect: true,
      questionTypes: [
        { value: 'BOOLEAN', name: this.$t('question.create.type.BOOLEAN') },
        { value: 'NUMERIC', name: this.$t('question.create.type.NUMERIC') },
        { value: 'ENUM', name: this.$t('question.create.type.ENUM') },
        { value: 'TEXT', name: this.$t('question.create.type.TEXT') },
        { value: 'FILE', name: this.$t('question.create.type.FILE') },
      ],
      oldTypeValue: null,
    }
  },
  methods: {
    handleSelect(value) {
      this.oldTypeValue = this.value
      if (this.answers.length > 0) {
        this.$refs.modalConfirmTypeChange.open(this.resetAnswers)
      }
      this.$emit('input', value)
    },
    cancelTypeChange() {
      this.$nextTick(() => {
        this.$emit('input', this.oldTypeValue)
      })
    },
    resetAnswers() {
      this.$emit('resetAnswers')
    }
  }
}
</script>
